import { useEffect, useState } from 'react';
import {
    Accordion,
    AccordionHeader,
    AccordionBody,
    AccordionItem
} from 'reactstrap';
import { Link, useLocation } from 'react-router-dom';
import MeniItems from './menuItems';
import PropTypes from 'prop-types';
import arrowRight from '../assets/images/icons/arrow-right-white.svg';

const CollapseNav = ({ item, pathname }) => {
    const [openId, setOpenId] = useState("");

    useEffect(() => {
        const Activeaccordion = item.Children.find(event => event.link === pathname);
        if (Activeaccordion) setOpenId(item.title);
    }, [item.Children, item.title, pathname]);

    const toggleAccordion = (id) => {
        setOpenId(openId === id ? '' : id);
    };

    return (
        <Accordion open={openId} toggle={toggleAccordion}>
            <AccordionItem>
                <AccordionHeader targetId={item.title}>
                    <span className="sd_mu_ic lt">{item.icon}</span>
                    <span className="sd_mu_tx">{item.title}</span>
                    <span className="sd_mu_ic rt">
                        <img src={arrowRight} alt="arrow-right-white" className='img-fluid' />
                    </span>
                </AccordionHeader>
                <AccordionBody accordionId={item.title}>
                    <ul>
                        {item.Children.map((row, index) => (
                            <li className={pathname === row.link ? "active" : ""} key={row.id || index}>
                                <Link to={row.link}>{row.title}</Link>
                            </li>
                        ))}
                    </ul>
                </AccordionBody>
            </AccordionItem>
        </Accordion>
    );
};

CollapseNav.propTypes = {
    item: PropTypes.object.isRequired,
    pathname: PropTypes.string.isRequired,
};

const DashboardSidebar = () => {
    const { pathname } = useLocation();

    return (
        <div className="ad_pg_bd">
            <div className="container-fluid p-0">
                <div className="row ad_bd_row g-0">
                    <div className="col-md-auto ad_pg_lt_spc-lg">
                        <div className="ad_pd_sd_menu ad_pg_lt_spc-lg">
                            <div className="ad_pd_sd_menu_inr">
                                <ul>
                                    {MeniItems[0]?.children?.map((n, i) => (
                                        n.type === "item" ? (
                                            <li className={pathname === n.link ? "active" : ""} key={n.id || i}>
                                                <Link to={n.link}>
                                                    <span className="sd_mu_ic lt">{n.icon}</span>
                                                    <span className="sd_mu_tx">{n.title}</span>
                                                    <span className="hvr_title">{n.title}</span>
                                                </Link>
                                            </li>
                                        ) : (
                                            <li key={n.id || i}>
                                                <CollapseNav item={n} pathname={pathname} />
                                            </li>
                                        )
                                    ))}
                                </ul>

                                <span style={{ fontSize: '14px' }}> v2.3</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DashboardSidebar;
